'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
import { Link } from '../Link';
type DropdownItemProps = {
  className?: string;
};
export function DropdownItem(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("group cursor-default rounded-lg px-3 py-1.5 focus:outline-hidden sm:px-4 sm:py-2", "text-left  font-normal text-sm text-zinc-950  dark:text-white forced-colors:text-[CanvasText]", "data-focus:bg-backgroundHover data-focus:text-white", "data-disabled:opacity-50", "forced-color-adjust-none forced-colors:data-focus:bg-[Highlight] forced-colors:data-focus:text-[HighlightText] forced-colors:data-focus:*:data-[slot=icon]:text-[HighlightText]", "col-span-full grid grid-cols-[auto_1fr] items-center", "*:data-[slot=icon]:col-start-1 *:data-[slot=icon]:row-start-1 *:data-[slot=icon]:mr-2.5 *:data-[slot=icon]:-ml-0.5 *:data-[slot=icon]:size-5 sm:*:data-[slot=icon]:mr-3 sm:*:data-[slot=icon]:size-4", "*:data-[slot=icon]:text-contentSecondary data-focus:*:data-[slot=icon]:text-white  dark:data-focus:*:data-[slot=icon]:text-white", "*:data-[slot=avatar]:mr-2.5 *:data-[slot=avatar]:-ml-1 *:data-[slot=avatar]:size-6 sm:*:data-[slot=avatar]:mr-2 sm:*:data-[slot=avatar]:size-5", "data-hover:bg-backgroundHover", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const classes = t1;
  let t2;
  if ($[5] !== classes || $[6] !== props) {
    t2 = "href" in props ? <Headless.MenuItem as={Link} {...props} className={classes} /> : <Headless.MenuItem as="button" type="button" {...props} className={classes} />;
    $[5] = classes;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}